import sitecoreIds from 'src/app_config/sitecore-ids.json';

import { Field, Item } from '@sitecore-jss/sitecore-jss-nextjs';

import { ExtendedItem } from 'src/types/ExtendedItem';

export function parseTypesOfResources(field: Field | Item | Item[] | undefined): string[] | null {
	let typeOfResources: string[] | null = [];
	try {
		(field as Item[])
			.filter((resource: ExtendedItem) => resource.templateId === sitecoreIds.Templates.TypesOfResourceTagTemplateId)
			.map((typeOfResource) => typeOfResources?.push((typeOfResource?.fields?.Title as Field<string>).value));
	} catch (error) {
		console.error(error);
		typeOfResources = null;
	}

	return typeOfResources;
}

export function parseTypesOfResourcesString(field: Field | Item | Item[] | undefined): string {
	const typeOfResources: string[] = [];
	try {
		(field as Item[])
			.filter((resource: ExtendedItem) => resource.templateId === sitecoreIds.Templates.TypesOfResourceTagTemplateId)
			.map((resource: ExtendedItem) => {
				typeOfResources.push((resource.fields.Title as Field<string>).value);
			});
	} catch (error) {
		console.error(error);
		return '';
	}
	if (typeOfResources.length < 1) {
		return '';
	}

	return typeOfResources.join(', ');
}
